import { updateCustomerPreferences, getUserPreferences } from '../../lib/customer-preference';
import type { CustomerPreferences } from '@/types/user-context';
import { useStore } from '@/store/store';

export const DYB_INTERSTITIAL_MAX_TIMES_SHOWN = 4;

export const setDYBCounterInUserPreferences = async (nrOfViews: number) => {
    if (typeof window === 'undefined') {
        return;
    }

    try {
        await updateCustomerPreferences({ showDYBTutorialCounter: nrOfViews });

        // Update the store after successful API call, matching old behavior
        useStore.getState().siteWideJackpot.setDYBUserPreferences({
            showDYBTutorialCounter: nrOfViews
        });
    } catch (err) {
        console.error(err);
    }
};

export const setDYBV2CounterInUserPreferences = async (nrOfViews: number) => {
    if (typeof window === 'undefined') {
        return;
    }

    try {
        await updateCustomerPreferences({ showDYBTutorialV2Counter: nrOfViews });

        useStore.getState().siteWideJackpot.setDYBUserPreferences({
            showDYBTutorialV2Counter: nrOfViews
        });
    } catch (err) {
        console.error(err);
    }
};

export const incrementDYBTutorialCounter = async (isSWJTutorialV2: boolean, currentCount: number) => {
    if (typeof window === 'undefined') {
        return;
    }

    const newCount = currentCount + 1;
    try {
        if (isSWJTutorialV2) {
            await updateCustomerPreferences({ showDYBTutorialV2Counter: newCount });
            useStore.getState().siteWideJackpot.setDYBUserPreferences({ showDYBTutorialV2Counter: newCount });
        } else {
            await updateCustomerPreferences({ showDYBTutorialCounter: newCount });
            useStore.getState().siteWideJackpot.setDYBUserPreferences({ showDYBTutorialCounter: newCount });
        }
    } catch (err) {
        console.error(err);
    }
};

export const getDYBUserPreferences = async (): Promise<CustomerPreferences | null> => {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        return await getUserPreferences();
    } catch (err) {
        console.error('Error fetching DYB user preferences:', err);
        return null;
    }
};
